import { put, takeEvery } from "redux-saga/effects";
import { fetchMethod } from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  VIEW_COACH_STATE_START: "VIEW_COACH_STATE_START",
  VIEW_COACH_STATE_SUCCESS: "VIEW_COACH_STATE_SUCCESS",
  VIEW_COACH_STATE_FAILED: "VIEW_COACH_STATE_FAILED"
};

// ============================================ Actions ========================================================

export const viewCoachStateStart = data => ({
  type: actionType.VIEW_COACH_STATE_START,
  payload: data
});

export const viewCoachStateSuccess = data => ({
  type: actionType.VIEW_COACH_STATE_SUCCESS,
  payload: data
});

export const viewCoachStateFailed = data => ({
  type: actionType.VIEW_COACH_STATE_FAILED,
  payload: data
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null
};

export default function viewCoachStateReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.VIEW_COACH_STATE_START:
      return {
        ...state,
        loading: true
      };

    case actionType.VIEW_COACH_STATE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };
    case actionType.VIEW_COACH_STATE_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* viewCoachStateSaga(action) {
  try {
    const response = yield fetchMethod(`/api/useracivities/coachViewsByState`,action.payload.variables,'post',true);
    if (response && response.status === 200) {
      yield put(
        viewCoachStateSuccess({data: response.data.response.data})
      );
    } else {
      messagePopup("", "View Coach Api failed", "error");
      yield put(viewCoachStateFailed("View Coach Api failed"));
    }
  } catch (error) {
    messagePopup("", "View Coach Api failed", "error");
    yield put(viewCoachStateFailed("View Coach Api failed"));
  }
}

export function* watchViewCoachStateSaga() {
  yield takeEvery(actionType.VIEW_COACH_STATE_START, viewCoachStateSaga);
}
